export const SEARCH_MODE_BASIC = 'basic' as const;
export const SEARCH_MODE_ADVANCED = 'advanced' as const;

/**
 * For sending updated search mode preferences to the server,
 * which uses different keys to the browser
 *
 * For e.g.
 * Frontend: 'basic' vs Backend: 'BASIC'
 */
export const SERVER_SEARCH_MODE_BASIC = 'BASIC';
export const SERVER_SEARCH_MODE_ADVANCED = 'ADVANCED';

/**
 * IMPORTANT: NATURAL LANGUAGE MODE IS A BETA MODE ONLY AVAILABLE IN NIN
 */
export const DEFAULT_SEARCH_MODE = SEARCH_MODE_BASIC;

export const mapSearchModeToAnalyticAtribute = {
	[SEARCH_MODE_BASIC]: SEARCH_MODE_BASIC,
	[SEARCH_MODE_ADVANCED]: 'JQL',
};

export const SEARCH_MODE_SWITCHER_LEFT_LOCATION = 'Left' as const;
export const SEARCH_MODE_SWITCHER_RIGHT_LOCATION = 'Right' as const;

export const PACKAGE_NAME = 'jiraJqlBuilder';
export const TEAM_NAME = 'empanada';
